import { render } from "./InventarioDetallePage.vue?vue&type=template&id=480fbfbd&scoped=true"
import script from "./InventarioDetallePage.vue?vue&type=script&lang=js"
export * from "./InventarioDetallePage.vue?vue&type=script&lang=js"

import "./InventarioDetallePage.vue?vue&type=style&index=0&id=480fbfbd&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480fbfbd"]])

export default __exports__